/* eslint-disable class-methods-use-this */
/* global axios */
import JwtAuth from './jwtAuth';

const url =
  process.env.FRONTEND_ENV === 'develop'
    ? 'https://staging.chatlyn.com/keystone/api'
    : window.location.protocol +
      '//' +
      window.location.hostname +
      '/keystone/api';

class KeystoneAPI {
  _runFlow = async (flowId, payload) => {
    const jwtAuthTokens = await JwtAuth.getUserTokens();

    return axios.post(`${url}/conversation/${flowId}/run`, payload, {
      headers: {
        Authorization: `Bearer ${jwtAuthTokens.access_token}`,
      },
    });
  };

  getSuggestions = async (flowId, payload) => {
    return this._runFlow(flowId, payload);
  };

  getImprovement = async (flowId, payload) => {
    return this._runFlow(flowId, payload);
  };
}

export default new KeystoneAPI();
